import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import type { VendorSearchItem } from '@goodfynd/maps';
import { VendorEventMapCanvas } from '@goodfynd/maps';
import { Text } from '@goodfynd/ui';
import { Link } from '@goodfynd/ui';
import { getOrganizationRoutePath } from 'utils/routes-util';

import config from '../../../config';
import routes from '../../../config/routes';
import { useOrganization } from '../../../context/OrganizationContext';
import { useVendorApi } from '../../../hooks/api';
import type { SearchResults } from '../../../types/search-legacy';
import type { VendorScheduleRequest } from '../../../types/vendors';
import { OverviewCard } from '../overview-card';

import { PreOrderingPinHover } from './pre-ordering-pin-hover';
export default function OrganizationPreOrderingOverview() {
  const { organization, organizationId, organizationNameId } =
    useOrganization();

  const api = useVendorApi();

  /* Fetch schedule events open for pre-ordering */
  const request = useMemo<VendorScheduleRequest>(
    () => ({
      page: 1,
      rows: 100,
      vendorOrganizationId: organizationId,
    }),
    [organizationId]
  );
  const { data, isError, isLoading } = useQuery<
    SearchResults<VendorSearchItem>,
    unknown
  >([config.queryKeys.openVendors, organizationId], () =>
    api.getOpenVendors(request)
  );

  return (
    <OverviewCard
      headerCss={{ padding: '16px 16px 8px' }}
      showDateFilter={false}
      title="Upcoming Schedule"
      contentCss={{
        height: 'calc(100% - 44px)',
        marginTop: -24,
      }}
      css={{
        overflow: 'hidden',
        padding: 0,
      }}
      titleRight={
        <Link
          href={getOrganizationRoutePath(
            routes.organization.schedule.map,
            organizationNameId
          )}
        >
          <Text as="subhead3" inherit>
            Expand
          </Text>
        </Link>
      }
    >
      <VendorEventMapCanvas
        busy={isLoading && '...loading map...'}
        css={{ minWidth: '100%' }}
        defaultCenter={organization.location}
        defaultZoom={9}
        error={isError && 'An unknown error has occurred'}
        renderMarkerHoverInfo={(info) => <PreOrderingPinHover item={info} />}
        results={data?.results}
      />
    </OverviewCard>
  );
}
